import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { bindActionCreators } from 'redux';
import * as actions from '../../../../actions/api.reports.lot.actions';
import * as home from '../../../../actions/process.home.actions';

import Hidden from '@material-ui/core/Hidden';

import Query from './Menu';
import Menu from '../Menu';
import List from './List';
import Error from '../../../dialogs/Error';

import Loading from '../../../dialogs/loading';

// eslint-disable-next-line
import style from './_styles.css';

class Lot extends React.Component {
    state = {
        hide: false,
        open: undefined,
        error: undefined,
    };

    handleScroll = (e) => {
        this.props.setProminentToolBar(e.currentTarget.scrollTop === 0);
    };

    handleBack = () => {
        /*
            let path = this.props.history.location.pathname.split('/');
            path.splice(path.length - 1, 1);
            path = path.join('/');
            this.props.history.push(path);
            */
           if(this.props.lastLocation && this.props.lastLocation.pathname === "/user/login") {
            this.props.history.push("/");
        } else {
            this.props.history.goBack();
        }  
    };

    render() {
        const { info, result, report_lot_is_loading } = this.props;
        const { error } = this.state;
        if (
            info &&
            info.security &&
            info.security.totalPermits &&
            !(info.security.totalPermits.some((f) => f === '20' || f === '60')  &&
              info.security.licencias.some((f) => f.id === 150 && f.activo ))
        ) {
            return <Error open id={'unauthorized_access'} handleClose={this.handleBack} />;
        } else if (error) {
            return <Error open message={error} handleClose={this.handleBack} />;
        } else {
            return (
                <div className={'flex_full_row heigth100 bg_ice_blue'}>
                    {report_lot_is_loading && <Loading open opacity />}
                    {!result
                        ? <React.Fragment>
                            <Hidden xsDown>
                                <div className={'flex_20 overflow_y_scroll padding_top_12 shadow_right_on_tablet bg_white'} >
                                    <Menu {...this.props} active="lot" />
                                </div>
                            </Hidden>
                            <div className={'flex_full bg_white center'} >
                                <Query {...this.props} />
                            </div>
                        </React.Fragment>
                        : <List {...this.props} />
                    }
                </div>
            );
        }
    }
}

const mapStateToProps = (state) => {
    return {
        info: state.info,
        report_lot: state.report_lot,
        report_lot_is_loading: state.report_lot_is_loading,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actions, home), dispatch);
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(Lot));



// WEBPACK FOOTER //
// ./src/components/complex/reports/lot/Index.js